import React from 'react';

const CampusOverviewHeader = () => {
  return (
    <div className='d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between mb-4 gap-3'>
      <div>
        <h1 className="mb-2 fw-bold" style={{ fontSize: '1.875rem', color: '#2e1065' }}>All Campuses Overview</h1>
        <p className="text-muted mb-0 small">Monitor performance and scores across your network</p>
      </div>
    </div>
  );
};

export default CampusOverviewHeader;

